import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PolizasEmitirService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description Emitir polizas
   * @params data
   * @params legal
   */
  postPolicySend(data: any, legal?: boolean): Observable<ArrayBuffer> {
    const headerConfig: any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };

    return this.http.post(
      environment.endpoints.urlBase +
      environment.endpoints.polizasEmitir.name,
      data,
      headerConfig
    );
  }
}
